import { DynamicStandaloneMarkup } from '@/components/Markup';
import { propClassName } from '@/styles/Prose';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';

export interface ProseProps extends ComponentProps<'div'> {
  colors?: ClassNameProp;
  markup?: string;
  size?: ClassNameProp;
  variant?: ClassNameProp;
}

const ProseComponent: Component<ProseProps> = ({ className, colors, markup, size, variant, ...props }) => {
  const colorsClassName = propClassName('colors', colors);
  const sizeClassName = propClassName('size', size);
  const variantClassName = propClassName('variant', variant);
  const componentClassName = cn('prose', colorsClassName, sizeClassName, variantClassName, className);

  return <DynamicStandaloneMarkup options={{ className: componentClassName }} {...{ markup }} {...props} />;
};

export const Prose = ProseComponent;
